import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime, money } from '../../utils/helpers';
import { isPerUnit } from './useServices';
import ServiceForm from './ServiceForm';
import '../../styles/money.css';

const statusChip = (s) => s === 'Done' ? 'chip ok' : s === 'Confirmed' ? 'chip male' : s === 'Cancelled' ? 'chip danger' : 'chip pend';

// Mobile Services — one card per engagement, grouped by day, money summarised.
export default function ServicesMobile({ vm }) {
  const {
    canView, canAdd, canEdit, canDelete, byDay, filtered, totals, loading,
    q, setQ, typeFilter, setTypeFilter, types, open, openAdd, openEdit, del,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Services</h1></div>
        <div className="card card-pad empty">You do not have access to services for this event.</div>
      </div>
    );
  }

  const call = (mobile) => { if (mobile) window.location.href = `tel:${String(mobile).replace(/\D/g, '')}`; };

  return (
    <div>
      <div className="mobile-toolbar guest-controls-sticky">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <strong style={{ fontSize: 16 }}>Services</strong>
          <span className="muted" style={{ fontSize: 12 }}>{filtered.length}</span>
          <div style={{ flex: 1 }} />
          {canAdd && <button className="btn primary sm" onClick={openAdd}>+ Add</button>}
        </div>
        <div className="mn-filter2">
          <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} aria-label="Service filter">
            <option value="">All services</option>
            {types.map(t => <option key={t.ServiceTypeId} value={t.ServiceTypeId}>{t.ServiceTypeName}</option>)}
          </select>
          <input type="search" placeholder="Search…" value={q} onChange={e => setQ(e.target.value)} />
        </div>
      </div>

      <div className="mn-tiles m">
        <div className="mn-tile"><span>Total{totals.plates ? ` · ${totals.plates} plates` : ''}</span><strong>{money(totals.total)}</strong></div>
        <div className="mn-tile ok"><span>Paid</span><strong>{money(totals.advance)}</strong></div>
        <div className="mn-tile due"><span>Balance</span><strong>{money(totals.balance)}</strong></div>
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : filtered.length === 0 ? (
          <div className="card card-pad empty" style={{ padding: '24px 16px' }}>
            <div style={{ fontSize: 30 }}>🍽️</div>
            <div style={{ fontWeight: 700, color: 'var(--ink)', marginTop: 6 }}>No services yet</div>
            <div style={{ fontSize: 13, marginTop: 4 }}>Add the caterer, event manager, DJ … with charges and advance.</div>
            {canAdd && <button className="btn primary" style={{ marginTop: 14, padding: '12px 20px' }} onClick={openAdd}>+ Add Service</button>}
          </div>
        ) : byDay.map(group => (
          <div key={group.date || 'nodate'}>
            <div className="step-label" style={{ marginTop: 8 }}>{group.date ? fmtDate(group.date) : 'No date yet'}</div>
            <div className="mobile-card-list">
              {group.items.map(row => (
                <div key={row.ServiceId} className="card card-pad mobile-record-card">
                  <div className="mobile-card-head">
                    <div style={{ minWidth: 0 }}>
                      <Link to={`/app/services/${row.ServiceId}`} className="mobile-title" style={{ fontWeight: 800 }}>{row.ServiceType}</Link>
                      <div className="muted" style={{ fontSize: 12 }}>{row.CompanyName || row.ContactName || '—'}</div>
                    </div>
                    <div style={{ flex: 1 }} />
                    <span className={statusChip(row.Status)}>{row.Status}</span>
                  </div>
                  <div className="mobile-meta">
                    <div>
                      {row.FunctionName || 'Whole event'}
                      {(row.StartTime || row.FunctionStartTime) ? ` · ${fmtTime(row.StartTime || row.FunctionStartTime)}` : ''}
                      {(row.EndTime || row.FunctionEndTime) ? ` – ${fmtTime(row.EndTime || row.FunctionEndTime)}` : ''}
                    </div>
                    {!row.itemised && isPerUnit(row.RateType) && (
                      <div className="muted">{money(row.Rate)} × {row.ConfirmedCount}</div>
                    )}
                  </div>
                  <div className="mn-money3">
                    <div><span>Total</span><strong>{money(row.TotalAmount)}</strong></div>
                    <div className="ok"><span>Paid</span><strong>{money(row.AdvancePaid)}</strong></div>
                    <div className={Number(row.BalanceAmount) > 0 ? 'due' : ''}><span>Balance</span><strong>{money(row.BalanceAmount)}</strong></div>
                  </div>
                  <div className="mobile-actions">
                    <Link className="btn light sm" to={`/app/services/${row.ServiceId}`}>Menu / jobs · payments</Link>
                    {row.ContactMobile && <button className="btn primary sm" onClick={() => call(row.ContactMobile)}>📞 Call</button>}
                    {canEdit && <button className="btn light sm" onClick={() => openEdit(row)}>Edit</button>}
                    {canDelete && <button className="btn danger sm" onClick={() => del(row)}>Remove</button>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

      {open && <ServiceForm vm={vm} />}
    </div>
  );
}
